import React, { useState, useEffect } from "react";
import PaymentsRequests from "./PaymentsRequests";
import NavBar from "../../../../components/NavBarAdmin";
import { Link, useParams } from "react-router-dom";

const PaymentsDetails = () => {
    let params = useParams();
    const [data, setData] = useState({
        paymentInfo: {
            id: 0,
            id_venues: 0,
            numRef: "",
            name: "",
            date_time: "",
            plan_days_period: "",
            billing_vat_value: "",
            status: "",
            venue: "",
            invoice: "",
        },
        billing_account: {
            id: 0,
            name_company: '',
            nipc: '',
            email: '',
            phone_country: '',
            phone_number: '',
            address: '',
            city: '',
            postal_code: '',
            country: '',
        },
    })

    const requestInfo = async () => {
        let info = await PaymentsRequests.getPaymentsDetails(params);
        if (info && info.status) {
            console.log(info.data)
            setData(info.data)
        }
    }

    useEffect(async () => {
        await requestInfo();
    }, [])


    const BillingAccountDetails = () => {
        return (
            <ul className="nav-billing less-space">
                <li><span>Nome Empresa:</span> {data.billing_account.name_company} </li>
                <li><span>NIF:</span> {data.billing_account.nipc} </li>
                <li><span>Email:</span> {data.billing_account.email} </li>
                <li><span>Telefone:</span> {data.billing_account.phone_number} </li>
                <li><span>Rua:</span> {data.billing_account.address} </li>
                <li><span>Cidade:</span> {data.billing_account.city} </li>
                <li><span>Código Postal:</span> {data.billing_account.postal_code} </li>
                <li><span>País:</span> {data.billing_account.country} </li>

            </ul>
        )
    }


    const PaymentActionsButton = () => {
        if (data.paymentInfo.status === "ACTIVE") return <></>;
        return (
            <>
                <button className="btn btn-success mt-5" onClick={() => handlerAcceptPayment()}>Aceitar Pagamento</button>
                <button className="btn btn-danger mt-5 ms-3">Cancelar Pagamento (soon)</button>
            </>
        )
    }

    const InvoiceActions = () => {
        if (data.paymentInfo.status === "ACTIVE") {
            if (data.paymentInfo.invoice === false) {
                return (
                    <>

                    </>
                )
            } else {
                return (
                    <div className="row">
                        <div className="col-2 " >
                            <label className="form-label" style={{ fontWeight: "bold" }}>Fatura Nº</label>
                            <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.invoice?.invoice_number}></input>
                        </div>
                        <div className="col-2 " >
                            <label className="form-label" style={{ fontWeight: "bold" }}>Data Fatura</label>
                            <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.invoice?.invoice_date}></input>
                        </div>
                        <div className="col-2 " >
                            <label className="form-label" style={{ fontWeight: "bold" }}>Sub Total</label>
                            <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.invoice?.amount}></input>
                        </div>
                        <div className="col-2 " >
                            <label className="form-label" style={{ fontWeight: "bold" }}> Taxa iva</label>
                            <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.invoice?.tax_amount_percentage}></input>
                        </div>

                    </div>
                )
            }
        }
        return <></>;
    }

    const handlerAcceptPayment = async () => {
        let request = await PaymentsRequests.setPaymentsAccept(params);
        if (request && request.status) {
            await requestInfo();
        }
    }

    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-xs-12 dashboard-content">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="dashboard-h2"> Payment Details</h2>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-2 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Referencia Transação</label>
                                <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.numRef}></input>
                            </div>
                            <div className="col-2 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Data</label>
                                <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.date_time}></input>
                            </div>
                            <div className="col-2 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Plano</label>
                                <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.name}></input>
                            </div>
                            <div className="col-2 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Status</label>
                                <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.status}></input>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <h2>Info Pagamento</h2>
                            <div className="col-2 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Valor</label>
                                <input type="text" readOnly className="form-control-plaintext text-light" value={data.paymentInfo.billing_vat_value}></input>
                            </div>
                            <div className="col-10 " >
                                <PaymentActionsButton />
                                <InvoiceActions />
                            </div>

                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-12">
                                <h2>Billing data</h2>
                                <BillingAccountDetails />
                            </div>
                        </div>
                    </div>
                </div>
            </NavBar>
        </div>
    )
}


export default PaymentsDetails;